export const content = `Yes—and it’s a great way to make sure you never miss a session. When you create your account, you’ll have the chance to sign up for text reminders.

If you skip it during your account creation, that’s okay: You can still set up text reminders from your dashboard.

## How to set up text reminders

1. When you log in, scroll down to your **Action Items**.
2. Find the one that says “Sign up for text reminders and avoid cancellation fees.” Select **Sign Up**.
   ![](https://lh7-rt.googleusercontent.com/docsz/AD_4nXcPKER_8iKVAHsGExMz-j0h-Y2P6H9h1Qjgc6wp8rZMeCQhrfvik3OL453nRAU82UK2c6ol9NWsNFdL5hx36RtPMs0-n6j3_EyCCE5tgRYvZ2sfS2mLYHgddDiciztqkUL5QsAlzg?key=X_qAGGjtHqUyfCz1NzAHxOO7)
3. We’ll automatically text a 4-digit verification code to your phone number. Enter that code where we ask for it.
   ![](https://lh7-rt.googleusercontent.com/docsz/AD_4nXeZIvDnDgYngHVA9vuPxg9jV5tMzZAukuHfrFJhK0Ebk1DsR_0rlD4MQErwZg5SqSuyQ-BUOMxRRS9lKccW50Z4uN9TQ_a4taE9U-lNRXm0Us2QOauglrwHFp-aEKKPVBO0yb_kEQ?key=X_qAGGjtHqUyfCz1NzAHxOO7)
4. After you enter the code, select **Verify Mobile Number**.
   - If your code has expired or you didn’t receive one right away, use **Send New Code** to send yourself another one.
5. You’ll see **Text reminders ON** to let you know that you’ve successfully signed up.

## I don’t see the sign up option in my Action Items. What does that mean?

It might mean that you already have text reminders set up. If you don’t see the option but still aren’t getting reminders, send us an email at [help@joinuplift.co](mailto:help@joinuplift.co). We’ll help you get set up.

## How do I set up reminders if I change my phone number?

When you save a new mobile number, we’ll automatically add **Sign up for text reminders** back to your Action items.
`;
